import React from 'react';
import ContentPageLayout from '../components/ContentPageLayout';

function Contact() {
  return (
    <ContentPageLayout 
      title="About Us" 
      subtitle="Our mission, vision, and team"
      showBackButton
    >
      <div className="row">
        <div className="col-lg-8 mx-auto">
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4">
              <h3>About EduSpace</h3>
              <p>Content about your platform...</p>
            </div>
          </div>
        </div>
      </div>
    </ContentPageLayout>
  );
}

export default Contact;